import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Globals } from 'src/app/globals';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../service/auth.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginValid: boolean = false;
  showLoader: boolean = false;
  currentLang: string = "en";

  loginForm = new FormGroup({
    username: new FormControl('', [
      Validators.required,
      Validators.minLength(4),
      // Validators.pattern(/^(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/),
      Validators.maxLength(50)
    ]),
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(255),
    ]),
    lang: new FormControl('', []),
  });

  constructor(private toastrService: ToastrService, private authService: AuthService, private globals: Globals, public router: Router, public translate: TranslateService) {
    this.loginFormChange();
  }

  ngOnInit(): void {
    //this.globals.loadUserInfo();
    console.log(this.globals.currentUserInfo);
    if (this.globals.loggedIn) {
      this.router.navigate(['/home']);
    } else {
      this.globals.clearSession();
    }
  }

  loginFormChange() {
    this.loginForm.valueChanges.subscribe(val => {
      if (this.loginForm.valid) {
        this.loginValid = true;
      }
      else {
        this.loginValid = false;
      }
    });
  }

  loginFormSubmit() {

    if (this.loginForm.valid) {
      this.loginValid = false;
      this.showLoader = true;
      let username = this.loginForm.value.username;
      let password = this.loginForm.value.password;

      this.authService.login(username, password)
        .subscribe(
          data => {
            console.log(data)
            if (data.authStatus === 'SUCESS') {
              let uid = data;
              uid.logged_in = true;
              uid.sessionTime = new Date().getTime();
              localStorage.setItem(this.globals.UID, JSON.stringify(uid));
              let username = data.username;

              this.authService.getUserRoles(username).subscribe(
                data => {
                  let uRoles = data;
                  localStorage.setItem(this.globals.UROLE, JSON.stringify(uRoles));

                  this.authService.getUserOptions(username)
                    .subscribe(
                      data => {
                        let uOptions = data;
                        localStorage.setItem(this.globals.UOP, JSON.stringify(uOptions));
                        this.globals.loggedIn = true;
                        this.globals.loadUserInfo();
                        this.router.navigate(['/home'], { replaceUrl: true });
                        this.toastrService.success(this.translate.instant('WELCOME') + username);
                      },
                      error => {
                        this.toastrService.error(this.translate.instant('CAN_NOT_GET_OPTIONS'));
                        console.log(error);
                        this.loginValid = true;
                        this.showLoader = false;
                        localStorage.clear;
                      },
                    );
                },
                error => {
                  this.toastrService.error(this.translate.instant('CAN_NOT_GET_USER_ROLE'));
                  this.loginValid = true;
                  this.showLoader = false;
                  localStorage.clear;
                },
              );
            } else {
              this.toastrService.error(this.translate.instant('AUTH_FAIL'));
              console.log("error message: " + data);
            }
            this.loginValid = true;
            this.showLoader = false;
          },
          error => {
            this.toastrService.error(this.translate.instant('AUTH_FAIL'));
            console.log(error);
            this.loginValid = true;
            this.showLoader = false;
          },
          () => this.showLoader = false
        );
    }

  }

  changeLang() {
    // console.log("test : " + this.loginForm.controls.lang.value);
    this.currentLang = this.loginForm.controls.lang.value;
    this.globals.changeLang(this.currentLang);
    // setTimeout(() => {
    //   console.log('sleep');
    //   this.translate.use(this.currentLang);
    //   // And any other code that should run only after 1s
    // }, 1000);
    this.translate.use(this.currentLang);

  }

}
